/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export class MapOptions {
  assets: boolean;
  people: boolean;
  perimeters: boolean;
  breadcrumbs: boolean;
  zones: boolean;
  zonenames: boolean;
  zoomToZone: boolean;
  sublocations: boolean;
  sublocationnames: boolean;
  objectsOfInterest: string;
}
